import type { ServiceQueryOptionType } from '@/types/service'

import { api } from '@/lib/axios'

import type {
  KlbPetaniBppResponse,
  KlbPetaniCityResponse,
  KlbPetaniProvinceResponse,
  // KlbPetaniResponse, // dead code: dipakai oleh getKlbPetani lama (di-comment out)
  LahanPercontohanResponse,
  PenyuluhPertanianResponse,
  PotensiWilayahResponse
} from './types'

const PENYULUH_PERTANIAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:penyuluh_pertanian', key] as const

const getPenyuluh = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<PenyuluhPertanianResponse> => ({
  queryKey: PENYULUH_PERTANIAN_QUERY_KEY({ id, page, per_page }),
  queryFn: async () => {
    const res = await api.get<PenyuluhPertanianResponse>(
      `/report/kelembagaan/klb/table-penyuluh-nasional/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

const POTENSI_WILAYAH_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:potensi_wilayah', key] as const

const getPotensiWilayah = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<PotensiWilayahResponse> => ({
  queryKey: POTENSI_WILAYAH_QUERY_KEY({ id, page, per_page }),
  queryFn: async () => {
    const res = await api.get<PotensiWilayahResponse>(
      `/report/kelembagaan/klb/table-potensi-wilayah/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

const LAHAN_PERCONTOHAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:lahan_percontohan', key] as const

const getLahanPercontohan = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<LahanPercontohanResponse> => ({
  queryKey: LAHAN_PERCONTOHAN_QUERY_KEY({ id, page, per_page }),
  queryFn: async () => {
    const res = await api.get<LahanPercontohanResponse>(
      `/report/kelembagaan/klb/table-lahan-percontohan/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

const KLB_PETANI_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:klb_petani', key] as const

// Dead code: digantikan oleh getKlbPetaniProvince
// const getKlbPetani = ({
//   id,
//   page,
//   per_page
// }: {
//   id: string
//   page?: number
//   per_page?: number
// }): ServiceQueryOptionType<KlbPetaniResponse> => ({
//   queryKey: KLB_PETANI_QUERY_KEY({ id, page, per_page }),
//   queryFn: async () => {
//     const res = await api.get<KlbPetaniResponse>(
//       `/report/kelembagaan/klb/table-kelembagaan-petani-nasional/${id}`,
//       {
//         params: {
//           page,
//           per_page
//         }
//       }
//     )
//
//     return {
//       message: res.data.message,
//       data: res.data.data ?? [],
//       meta: res.data.meta
//     }
//   }
// })

const KLB_PETANI_BPP_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:klb_petani_bpp', key] as const

const getKlbPetaniBpp = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<KlbPetaniBppResponse> => ({
  queryKey: KLB_PETANI_BPP_QUERY_KEY({ id, page, per_page }),
  queryFn: async () => {
    const res = await api.get<KlbPetaniBppResponse>(
      `/report/kelembagaan/klb/table-kelembagaan-petani-kecamatan/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

const getKlbPetaniProvince = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<KlbPetaniProvinceResponse> => ({
  queryKey: KLB_PETANI_QUERY_KEY({ id, page, per_page, level: 'province' }),
  queryFn: async () => {
    const res = await api.get<KlbPetaniProvinceResponse>(
      `/report/kelembagaan/klb/table-kelembagaan-petani-nasional/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

const PENYULUH_BPP_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:penyuluh_bpp', key] as const

const getPenyuluhBpp = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<PenyuluhPertanianResponse> => ({
  queryKey: PENYULUH_BPP_QUERY_KEY({ id, page, per_page }),
  queryFn: async () => {
    const res = await api.get<PenyuluhPertanianResponse>(
      `/report/kelembagaan/klb/table-penyuluh-kecamatan/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

const PENYULUH_CITY_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:penyuluh_city', key] as const

const getPenyuluhCity = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<PenyuluhPertanianResponse> => ({
  queryKey: PENYULUH_CITY_QUERY_KEY({ id, page, per_page }),
  queryFn: async () => {
    const res = await api.get<PenyuluhPertanianResponse>(
      `/report/kelembagaan/klb/table-penyuluh-kota/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

const KLB_PETANI_CITY_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['table:klb_petani_city', key] as const

const getKlbPetaniCity = ({
  id,
  page,
  per_page
}: {
  id: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<KlbPetaniCityResponse> => ({
  queryKey: KLB_PETANI_CITY_QUERY_KEY({ id, page, per_page }),
  queryFn: async () => {
    const res = await api.get<KlbPetaniCityResponse>(
      `/report/kelembagaan/klb/table-kelembagaan-petani-kota/${id}`,
      {
        params: {
          page,
          per_page
        }
      }
    )

    return {
      message: res.data.message,
      data: res.data.data ?? [],
      meta: res.data.meta
    }
  }
})

export const tables = {
  getPenyuluh,
  getPenyuluhBpp,
  getPenyuluhCity,
  getPotensi: getPotensiWilayah,
  getLahan: getLahanPercontohan,
  // getKlb: getKlbPetani, // dead code: digantikan oleh getKlbProvince
  getKlbProvince: getKlbPetaniProvince,
  getKlbBpp: getKlbPetaniBpp,
  getKlbCity: getKlbPetaniCity
}
